export const projectCase = [
    // {
    //     id: '2',
    //     title: '塔城市“平安城市”PPP项目监控系统',
    //     img:{src:require('@/assets/img/city.png')},
    //     text: '塔城市“平安城市”PPP项目总投资2.14亿元，我公司联合中国兵器成都西物信安智能系统有限公司实施了该项目的投融资及建设、运营、维护工作。系统监控平台共接入监控2万路左右，其中，视频专网接入约4000路视频监控，社会资源面接入约16000路视频监控。'
    // },
    // {
    //     id: '2',
    //     title: '塔城市“智慧城市”三维地理信息平台',
    //     img:{src:require('@/assets/img/platfrom.png')},
    //     text: '塔城市“智慧城市”三维地理信息平台应用于塔城“智慧城市”项目及“一体化联合作战”平台的的基础应用支撑平台，我公司承接了平台架设及三维地图建模项目。'
    // },
    // {
    //     id: '3',
    //     title: '南充文化旅游职业学院智慧校园系统',
    //     img:{src:require('@/assets/img/nanchong.jpg')},
    //     text: '南充文化旅游职业学院智慧校园系统，系统集成BIM技术、物联网技术、私有云部署技术、视频结构化技术、人脸识别技术、热成像技术等行业最新技术，包含智慧校园可视化管理平台、视频监控系统、智慧消防管理系统、能耗管理系统、一卡系统、实训系统、图书馆管理系统、智慧黑板系统、背景广播系统、楼控系统、门禁系统、机房工程系统、精品录播系统、校园电视台系统等十几个子系统，建成了行业一流的智慧校园应用系统。'
    // },
    // {
    //     id: '4',
    //     title: '某市青少年宫三维智能化管理平台',
    //     img: {src:require('@/assets/img/childrenAdmin.png')},
    //     text: '某市青少年宫三维智能化管理平台实现综合安防系统、信息设施系统、建筑设备管理系统等相关子系统的整合应用、综合管理。该平台利用BIM初步成果进行深化，形成青少年宫大楼3D虚拟地图，将各子系统的运行状态、信息数据进行呈现。'
    // },
    // {
    //     id: '5',
    //     title: '四川省消防救援总队“三室”改造项目',
    //     img: {src:require('@/assets/img/freeRescue.png')},
    //     text: '四川省消防救援队“三室”改造项目含纪委谈话室、执纪档案室、干部廉政党案室建设，系统除建设了专业的谈话系统、档案管理系统外，还采用了我公司自主研发的物联网管理系统，集成对“三室”的BIM建模、设备管理、智慧消防管理、环境监测等建设内容。'
    // },
    {
        id: '3',
        title: '成都理工大学下穿隧道监控系统',
        img: {src:require('@/assets/img/cdtechnikon.webp')},
        text: '我公司承接了号称成都市最复杂五路口理工大学下穿隧道监控系统，系统含组态控制软件、PLC控制箱、情报板、监控系统、火灾报警系统、紧急电话系统等子系统，系统控制逻辑关系复杂，智能化程度高，是行业的样板工程项目。'
    },
    {
        id: '4',
        title: '仪陇县人民医院智能化项目',
        img: {src:require('@/assets/img/yilongHosipital.png')},
        text: '我公司承接了南充市仪陇县人民医院智能化系统工程，含综合布线工程、监控系统工程等。'
    },
    {
        id: '5',
        title: '龙山隧道智慧监控系统',
        img: {src:require('@/assets/img/longshanTunnel.png')},
        text: '我公司承接了温州龙山隧道智慧监控系统，系统含组态控制软件：防火帘卷门控制，气象站风速风向，一氧化碳，射流风机控制，能见度，光照度，车流量监测，车辆超重检测、情报板、监控系统、火灾报警系统、紧急电话系统隧道灯控等子系统。'
    },
    {
        id: '6',
        title: '天全县人民医院智能化系统项目',
        img: {src:require('@/assets/img/tianquanHosipital.png')},
        text: '我公司承接了天全县人民医院智能化系统工程，该项目为灾后重建项目，包含综合布线工程、监控系统工程、停车场系统工程、机房工程等。'
    },
    {
        id: '7',
        title: '巴中恩阳电子卡口系统',
        img: {src:require('@/assets/img/bazhongClasp.png')},
        text: '我公司承接了巴中市恩阳区电子卡口系统工程，该工程与巴中市联通公司联合开展，集测速抓拍、治安卡口功能为一体。是交警部门、公安部门重要的执法工具。'
    },
    {
        id: '8',
        title: '泸州叙永县平安城市项目',
        img: {src:require('@/assets/img/luzhou.png')},
        text: '我公司承接了泸州叙永县平安城市项目前端设备安装施工及调试、通信光缆架设、维护等工作。合作方：高斯贝尓数码科技股份有限公司。'
    },
    {
        id: '9',
        title: '绵阳乐荟城建筑智能化项目',
        img: {src:require('@/assets/img/mianyang.png')},
        text: '绵阳乐荟城建筑面积约8万平米，是集星级酒店、写字楼卖场等业态一体的商业综合体，我公司承接了乐荟城的建筑智能化项目。'
    },
    // {
    //     id: '13',
    //     title: '流星花园智能化系统',
    //     img: {src:require('@/assets/img/park.png')},
    //     text: '我公司承接了成都流星花园智能化系统建设，项目建筑面积4.5万平米，含住宅、商业业态。本项目建筑智能化系统包括楼宇对讲、监控系统、综合布线系统、停车场管理系统、周界报警系统等。'
    // },
    {
        id: '10',
        title: '成都市第五人民医院中心机房工程项目',
        img: {src:require('@/assets/img/cdfiveHosipital.png')},
        text: '我公司承接了成都市第五人民医院中心机房工程，监控系统工程、综合布线系统工程。其中，中心机房工程我公司选用国内外最高端的设备和产品，为整个医院的信息化系统提供了保驾护航。'
    },
    {
        id: '11',
        title: '太平园国际家博城智能化项目',
        img: {src:require('@/assets/img/taipingyuan.png')},
        text: '我公司承接了太平园国际家居博览城的建筑智能化系统工程，太平园国际家居博览城位于成都绕城高速接待寺路口，建筑面积30万平方米。总规划集五星级酒店、商业卖场、写字楼为一体。现已经建成一期商业卖场。'
    },
    {
        id: '12',
        title: '遂宁市会展中心智能化项目',
        img: {src:require('@/assets/img/suining.png')},
        text: '我公司承接了遂宁市会展中心智能化项目，遂宁市会展中心土建总包由中国中铁八局负责，我公司承接了监控系统、综合布线系统、中心机房建设等智能化项目。其中，会展中心报告厅是遂宁市政府重要会议的主要召开地。是遂宁市地标建筑，形象窗口。'
    },
    {
        id: '13',
        title:'米易县岷山饭店智能化项目',
        img: {src:require('@/assets/img/miyiHotel.png')},
        text: '岷山饭店是成都老牌的五星级酒店，攀枝花岷山饭店是岷山饭店的第一家加盟店，全部按照岷山饭店的规格打造，攀枝花岷山饭店是一家真正的四星级酒店，包含了星级酒店应有的设备设施，其建筑智能化项目也照高规格打造，我公司承接的岷山饭店的建智能化项目包含二十几个子系统，是酒店行业的智能化项目典范。'
    },
    {
        id: '14',
        title: '英联国际商务中心智能化项目',
        img: {src:require('@/assets/img/businessCenter.png')},
        text: '英联国际商务中心位于成都市火车南站西路，总占地10余亩，建筑面积近5万平米，是集星级酒店、写字楼卖场等业态的商业综合体，建筑总承包单位为成都市第一建筑工程公司，我公司承接了英联商务中心的建筑智能化系统工程。'
    }
]